import { v4 } from 'uuid'
import * as api from '../services/api'
import { assignScriptToProject } from '../services/api/project'
import { upsertInfo } from '../services/api/script'
import showPaywall from '../services/show-paywall'
import { canAccessVideoEditor } from './video-editor-access'
const WEB_HOST = process.env.REACT_APP_WEB_HOST

const onCreateScript = async ({ data, user }) => {
  const scriptUuid = v4()
  if (user) {
    await upsertInfo({
      scriptUuid,
      data: data
    })
  }
  return { uuid: scriptUuid }
}

/**
 * `activeWorkspace` is optional: callers that render inside a workspace-aware
 * screen pass it so a free user holding a team seat is not turned away. Callers
 * without workspace context (the `/verify` deep link) fall back to the personal
 * subscription, which is the safe answer.
 */
const createVideoProject = async (user, { activeWorkspace } = {}) => {
  if (!user) {
    window.location.href = `${WEB_HOST}/login`
    return
  }
  // The AI Video editor is paid-only. Stop here rather than at the editor
  // route, so a free user does not get an empty project and a stray screenplay
  // created for a surface they cannot open.
  if (!canAccessVideoEditor({ user, activeWorkspace })) {
    showPaywall('creator', { paywallType: 'feature', featureName: 'aiVideo', trigger: 'create_video_project' })
    return null
  }
  try {
    const project = await api.project.createProject({
      title: 'Untitled Project',
      description: '',
      type: {
        label: 'Feature Film',
        value: 'featureFilm'
      }
    })
    const scriptLanguage = { code: 'en', name: 'English' }
    const db = await onCreateScript({
      data: {
        title: 'Untitled Screenplay',
        synopsis: '',
        type: 'featureFilm',
        language: scriptLanguage,
        action: 'videoEditor',
        genre: JSON.stringify([])
      },
      user
    })
    await assignScriptToProject({ scriptUuid: db.uuid, projectUuid: project.uuid })
    return {
      projectUuid: project.uuid,
      uuid: db.uuid
    }
  } catch (error) {
    console.error(error)
    if (error.code && error.code === 'LIMIT_EXCEEDED') {
      showPaywall('basic', { paywallType: 'limit', featureName: 'projectCreation', trigger: 'create_video_project' })
    }
    return null
  }
}

export default createVideoProject
